import React, { useContext, useState } from "react";
import {
  applyCouponcode,
  applyRestaurantCouponcode,
  removecoupon,
} from "../../../../../../config/Services";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import { UserContext } from "../../../../../../App";
import { Button, CircularProgress, Container, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getCouponState } from "../../redux/Reducers/couponReducer";
import { useDispatch } from "react-redux";
import { addcoupon } from "../../redux/Actions/couponActions";
import { useSnackbar } from "layouts/ecommerce/product/hooks/SnackbarProvider";
import useGetDevice from "../../../hooks/useGetDevice";
import StyledButton from "../custom/StyledButton";
import { SlArrowUp, SlArrowDown } from "react-icons/sl";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ConfettiExplosion from "react-confetti-explosion";
import "./index.css";
import { allProductsRenderType } from "../../redux/Actions/paginationActions";
import { getStoreCurrencySymbol } from "../../../../../../utils/currency";

const Couponcard = ({ item, setRenderType }) => {
  const showSnackbar = useSnackbar();
  const isMobile = useGetDevice();
  const { setTotal, setCgst, setSgst, setCouponApplied } = useContext(UserContext);
  let cartId = localStorage.getItem("CartId");
  const [loader, setLoader] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [isExploding, setIsExploding] = useState(false);
  const couponData = useSelector(getCouponState);
  const dispatch = useDispatch();
  const defaultImg = "https://i.imgur.com/T1KH34U.png";
  const retailType = localStorage.getItem("retailType");

  const confettiOptions = {
    force: 0.4,
    duration: 2200,
    particleSize: 6,
    particleCount: 30,
    width: 400,
  };

  const handleCouponState = (couponId) => {
    setLoader(true);
    let payload = {
      couponId: couponId,
      couponCode: "",
      cartId: cartId,
    };
    if (retailType === "RESTAURANT") {
      applyRestaurantCouponcode(payload)
        .then((res) => {
          if (
            res?.data?.status === "error" ||
            res?.data?.status === "ERROR" ||
            res?.data?.data?.es > 0
          ) {
            return showSnackbar(res?.data?.message || res?.data?.data?.message, "error");
          }
          showSnackbar(
            res?.data?.data?.data?.cartCoupon?.couponCode + " coupon applied successfully",
            "success"
          );
          dispatch(allProductsRenderType(""));
          dispatch(addcoupon(res?.data?.data?.data?.cartCoupon));
          setCouponApplied(res?.data?.data?.data?.cartCoupon?.couponValue);
          setCgst(res?.data?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.data?.billing?.sgst);
          setIsExploding(true);
          setTotal(res?.data?.data?.data?.billing?.totalCartValue);
          setLoader(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setLoader(false);
        });
    } else {
      applyCouponcode(payload)
        .then((res) => {
          showSnackbar(
            res?.data?.data?.cartCoupon?.couponCode + " coupon applied successfully",
            "success"
          );
          dispatch(allProductsRenderType(""));
          dispatch(addcoupon(res?.data?.data?.cartCoupon));
          setCouponApplied(res?.data?.data?.cartCoupon?.couponValue);
          setCgst(res?.data?.data?.billing?.cgst);
          setSgst(res?.data?.data?.billing?.sgst);
          setIsExploding(true);
          setTotal(res?.data?.data?.billing?.totalCartValue);
          setLoader(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setLoader(false);
        });
    }
  };

  const handleRemovecoupon = (couponId) => {
    setLoader(true);
    removecoupon(cartId)
      .then((res) => {
        showSnackbar("Coupon removed successfully", "success");
        setTotal(res?.data?.data?.billing?.totalCartValue);
        dispatch(allProductsRenderType(""));
        dispatch(addcoupon(null));
        setLoader(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
      });
  };

  return (
    <>
      {isMobile ? (
        <Box className="coupon-card">
          <Box className="coupon-card-body">
            <Box className="coupon-image-box">
              <img
                src={item?.image || defaultImg}
                alt="coupon-image"
                className="coupon-card-image"
              />
            </Box>
            <Stack direction="column" spacing={1} sx={{ flex: 1 }}>
              <div variant="h6" className="coupon-card-title">
                {item?.offerName}
              </div>
              <div variant="body1" className="coupon-card-description">
                {item?.description}
              </div>
              <Box className="coupon-card-footer">
                {/* <Chip label="code" size="small" color="secondary" variant="outlined" /> */}
                <Box className="coupon-card-code">
                  <div variant="body2" className="coupon-card-code-text">
                    {item?.couponCode}
                  </div>
                </Box>
                <div
                  variant="body2"
                  className="view-details-text"
                  onClick={() => setShowDetails(!showDetails)}
                >
                  {showDetails ? (
                    <>
                      Hide Details <ExpandLessIcon fontSize="small" />
                    </>
                  ) : (
                    <>
                      View Details <ExpandMoreIcon fontSize="small" />
                    </>
                  )}
                </div>
              </Box>
              {showDetails && (
                <Box className="coupon-card-details">
                  <div variant="body2" className="view-details-text">
                    {item?.termsAndConditions}
                  </div>
                </Box>
              )}
            </Stack>
          </Box>
          <Box className="coupon-card-btn">
            {loader ? (
              <Box className="apply-btn">
                <CircularProgress size={22} />
              </Box>
            ) : couponData?.couponCode === item?.couponCode ? (
              <Box className="applied-btn" onClick={() => handleRemovecoupon(item?.couponId)}>
                <DoneAllIcon fontSize="small" />
                {isExploding && <ConfettiExplosion {...confettiOptions} />}
                <div className="coupon-btn-text">APPLIED</div>
              </Box>
            ) : (
              <Box className="apply-btn" onClick={() => handleCouponState(item?.couponId)}>
                <div className="coupon-btn-text">TAP TO APPLY</div>
              </Box>
            )}
          </Box>
        </Box>
      ) : (
        <div key={item?.sourceId} className="couponDiv">
          <div className="coupon-container">
            <div style={{ width: "20%" }}>
              <img
                style={{ width: "100%", height: "75px", objectFit: "contain" }}
                src={item?.image || defaultImg}
                alt="err"
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "70%",
              }}
            >
              <div style={{ float: "left", fontSize: "15px", fontWeight: "bold" }}>
                {item?.offerName}
              </div>
              <div
                style={{
                  float: "left",
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "blue",
                }}
              >
                {item?.description}
              </div>
              <Chip
                sx={{ marginTop: "1rem" }}
                label={item?.couponCode}
                size="small"
                color="secondary"
                variant="outlined"
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                position: "relative",
              }}
            >
              <>
                {loader ? (
                  <CircularProgress size={24} />
                ) : (
                  <Box>
                    {couponData?.couponCode === item?.couponCode ? (
                      <Box
                        className="button-33-red"
                        onClick={() => handleRemovecoupon(item?.couponId)}
                      >
                        {" "}
                        Remove<p className="applied-text-red">{getStoreCurrencySymbol()}{couponData?.couponValue}</p>
                        {/* {isExploding && <ConfettiExplosion {...confettiOptions} />} */}
                      </Box>
                    ) : (
                      <Box className="button-33" onClick={() => handleCouponState(item?.couponId)}>
                        {" "}
                        Apply
                      </Box>
                    )}
                  </Box>
                )}
              </>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Couponcard;
